
import * as form from './form';
// import * as echart from './echart';
import * as download from './download';
import * as pagination from './pagination';
import * as data from './data';

//静态icon引入
import '../assets/iconfont/iconfont.css';

//构筑组件
const components = {
    ...form,
    ...data,
    // ...echart,
    ...download,
    ...pagination
}
//加载组件
const install = function (Vue, Option) {

    /** Object.keys() 方法会返回一个由一个给定对象的自身可枚举属性组成的数组 
    如：var arr = ['a', 'b', 'c']; console.log(Object.keys(arr));   ['0', '1', '2'] */
    Object.keys(components).forEach((key) => {

        /**
            console.log(components[key].name);
            poi-button

            console.log(components[key]);
            {name: "poi-button", props: {…}, computed: {…}, render: ƒ, staticRenderFns: Array(0), …}beforeCreate: [ƒ]beforeDestroy: [ƒ]computed: {btnStyle: ƒ, fstyle: ƒ}name: "poi-button"props: {type: {…}, size: {…}, freestyle: {…}}render: ƒ ()staticRenderFns: []_Ctor: {0: ƒ}__file: "src/components/form/button/button.vue"_compiled: true__proto__: Object

         */

        Vue.component(components[key].name, components[key])
    })
}

export default {
    ...components,
    install
}
